/**
 * @date: 2023-05-18
 * @author: Kevin Hsiau <khsiau@max.md>
 * @copy: (C) Copyright 2022 MaxMD Corporation, All Rights Reserved.
 */
import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {ApiUrl} from "../utils/portal-urls";
import {handleHttpResponse} from "../utils/http-helpers";

const initialState = {
    fhirInformationLoading: false,
    fhirEndpointResources: null,
    top3HispsCountBar: null,
    fhirSummary: null,
    fhirInformationDetails: null,
    fhirInformationMsg: null
}

export const getFhirInformation = createAsyncThunk(
    "fhirInformation/getFhirInformation",
    async (_, {rejectWithValue}) => {
        try {
            const res = await fetch(ApiUrl.Hisps.currentSync.getPath);
            return await handleHttpResponse(res);
        } catch (err) {
            return err && rejectWithValue("Failed to get current directory FHIR information");
        }

    }
)


export const currentDirectFhirInformationSlice = createSlice({
    name: 'fhirInformation',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getFhirInformation.pending, (state) => {
                state.fhirInformationLoading = true;
            })
            .addCase(getFhirInformation.fulfilled, (state, action) => {
                state.fhirInformationLoading = false;
                const content = action.payload;
                console.log('[FHIR] Raw API response:', content);
                console.log('[FHIR] Percent_of_FHIR_Endpoints:', content.Percent_of_FHIR_Endpoints);
                console.log('[FHIR] HISPs_Count_Comparison_CSV_to_FHIR:', content.HISPs_Count_Comparison_CSV_to_FHIR);
                console.log('[FHIR] Summary:', content.Summary);
                state.fhirEndpointResources = content.Percent_of_FHIR_Endpoints;
                state.top3HispsCountBar = content.HISPs_Count_Comparison_CSV_to_FHIR?.slice(0, 3);
                state.fhirInformationDetails = content.HISPs_Count_Comparison_CSV_to_FHIR;
                state.fhirSummary = content.Summary;
                console.log('[FHIR] State set — fhirEndpointResources:', state.fhirEndpointResources, '| top3HispsCountBar:', state.top3HispsCountBar, '| fhirSummary:', state.fhirSummary);
            })
            .addCase(getFhirInformation.rejected, (state, action) => {
                state.fhirInformationLoading = false;
                state.fhirInformationMsg = {error: action.payload};
                console.error('[FHIR] getFhirInformation rejected:', action.payload, '| full action:', action);
            })
    }
})

export default currentDirectFhirInformationSlice.reducer;